import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { KnowledgeContentComponent } from '../../../components/knowledge-content';
import { INTERNAL_ROUTING, ROUTES } from 'shared/constants';
import { useKnowledgeItem } from 'shared/hooks/knowledge-items.hooks';
import { ContentPreviewProvider } from './hooks/use-content-preview.hooks';
import { Loader } from '../../../components/core';

const KnowledgeContentEditorPage = React.memo(() => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const { data: item, isPending } = useKnowledgeItem(id);

  const onClose = React.useCallback(() => {
    navigate(
      state?.initialData?.categoryId
        ? `${ROUTES.KNOWLEDGE}?${INTERNAL_ROUTING.QUERY_PARAMS.KNOWLEDGE}=${state.initialData.categoryId}`
        : ROUTES.KNOWLEDGE,
    );
  }, [navigate, state]);

  // The editor's form takes its initial values once, so wait for the item.
  if (id && isPending) return <Loader />;

  return (
    <ContentPreviewProvider isHub={state?.isHub}>
      <KnowledgeContentComponent
        key={state?.initialData?.assetId || id}
        id={id}
        close={onClose}
        {...(item || {})}
      />
    </ContentPreviewProvider>
  );
});

export { KnowledgeContentEditorPage };
